import { Outlet, createFileRoute, useRouterState } from '@tanstack/react-router';
import { TemplateDetailPage } from '../features/templates/template-catalog-page';
export const Route = createFileRoute(
  '/manage/$companySlug/templates_/$templateId/versions/$version',
)({ component: RouteComponent });
function RouteComponent() {
  const { companySlug, templateId, version } = Route.useParams();
  const isChildRoute = useRouterState({
    select: (state) => state.location.pathname.endsWith('/edit'),
  });
  if (isChildRoute) return <Outlet />;
  return (
    <TemplateDetailPage
      companySlug={companySlug}
      templateId={templateId}
      version={Number(version)}
    />
  );
}
